export const COLORS = {
  white: "#ffffff",
  black: "black",

  // Darks
  dark_400: "#141723",
  dark_300: "#1d1f2e",
  dark_200: "#2e2f3d",
  dark_100: "#3b3e52",

  // Oranges
  orange_100: "#f5928e",
  orange_200: "#f26c68",
  orange_300: "#ed3731",

  //Pinks
  pink_100: "#e27896",
  pink_200: "#d84770",
  pink_300: "#a82449",

  //Purples
  purple_100: "#986bdb",
  purple_200: "#512494",
  purple_300: "#241042",

  // Hilites
  hilite_purpink: "#a6437d",
  gold: "#FFD700",
  fuschia: "#f7b3c2",

  //Whites
  whiteblue: "#8585ab",
};

export type ColorType = keyof typeof COLORS;
